import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

export default function DeleteConfirmDialog({ 
  open, 
  onClose, 
  onConfirm, 
  title = 'Confirm Delete', 
  message = 'Are you sure you want to delete this item? This action cannot be undone.' 
}) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
          bgcolor: "#2a2a2a",
          color: "#fff"
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <WarningIcon sx={{ fontSize: 48, color: '#ff6b6b' }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#fff' }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="body1" sx={{ color: '#ccc', lineHeight: 1.6 }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ 
            minWidth: 100,
            color: '#ccc',
            borderColor: '#555',
            '&:hover': { 
              borderColor: '#777',
              backgroundColor: 'rgba(255, 255, 255, 0.05)'
            }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            minWidth: 100,
            bgcolor: '#ff6b6b',
            color: 'white',
            '&:hover': { bgcolor: '#ff5252' },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}